import React from 'react';
import { Row, Anchor, Col, Typography, Space, Card, Divider, Tag, List } from 'antd';
import {
    SecurityScanOutlined, 
    TeamOutlined, 
    GlobalOutlined, 
    SolutionOutlined, 
    MonitorOutlined,
    SafetyCertificateOutlined,
    BankOutlined,
    InfoCircleOutlined,
    CheckCircleOutlined
} from '@ant-design/icons';
import GsrdWch from '../../components/GsrdWch';

const { Title, Paragraph, Text } = Typography;

export default function Ethics() {
    return (
        <div className="shared-hero-page" style={{ backgroundColor: '#f9fbff', minHeight: '100vh', paddingBottom: '100px' }}>
            {/* Hero Section */}
            <div className="shared-hero-banner" style={{
                padding: '100px 0 140px',
                textAlign: 'center',
                color: 'white',
                marginBottom: '-80px'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                    <Title level={1} style={{ color: 'white', fontSize: '48px', fontWeight: 800, marginBottom: '16px' }}>
                        Ethics & Compliance
                    </Title>
                </div>
            </div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <Row gutter={40}>
                    {/* Sticky Sidebar */}
                    <Col xs={24} md={6}>
                        <div style={{ position: 'sticky', top: '100px', zIndex: 10 }}>
                            <Card 
                                bordered={false} 
                                style={{ 
                                    borderRadius: '16px', 
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
                                    background: '#ffffff'
                                }}
                                bodyStyle={{ padding: '24px 16px' }}
                            >
                                <Title level={5} style={{ paddingLeft: '16px', marginBottom: '20px', color: '#055878', letterSpacing: '1px' }}>
                                    ETHICS GUIDELINES
                                </Title>
                                <Anchor
                                    offsetTop={100}
                                    items={[
                                        {
                                            key: 'part-1',
                                            href: '#part-1',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>1. Participant Privacy</span>,
                                        },
                                        {
                                            key: 'part-2',
                                            href: '#part-2',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>2. Institutional Trust</span>,
                                        },
                                        {
                                            key: 'part-3',
                                            href: '#part-3',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>3. Management Team</span>,
                                        },
                                        {
                                            key: 'part-4',
                                            href: '#part-4',
                                            title: <span style={{ fontSize: '14px', fontWeight: 500 }}>4. Regulatory Framework</span>,
                                            children: [
                                                { key: 'part-5', href: '#part-5', title: <span style={{ fontSize: '13px' }}>• Workflow</span> },
                                                { key: 'part-6', href: '#part-6', title: <span style={{ fontSize: '13px' }}>• Safeguards</span> },
                                                { key: 'part-7', href: '#part-7', title: <span style={{ fontSize: '13px' }}>• Oversight</span> },
                                            ]
                                        },
                                    ]}
                                />
                            </Card>
                        </div>
                    </Col>

                    {/* Main Content */}
                    <Col xs={24} md={18}>
                        <Space direction="vertical" size={40} style={{ width: '100%' }}>
                            
                            {/* Section 1 */}
                            <Card id="part-1" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <SecurityScanOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    1. Protecting Participant Privacy
                                </Title>
                                <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444' }}>
                                    Genomic data carries highly sensitive personal information. Leakage can result in serious impacts including:
                                </Paragraph>
                                <div style={{ background: '#fff1f0', borderLeft: '4px solid #ff4d4f', padding: '24px', borderRadius: '8px', marginTop: '20px' }}>
                                    <Paragraph style={{ color: '#851d1d', marginBottom: 0, fontSize: '16px' }}>
                                        - Exposure of disease risk and health conditions<br />
                                        - Genetic discrimination in employment or insurance<br />
                                        - Re-identification even after anonymization, especially when linked with other data
                                    </Paragraph>
                                </div>
                            </Card>

                            {/* Section 2 */}
                            <Card id="part-2" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <BankOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    2. Institutional Integrity and Trust
                                </Title>
                                <div style={{ padding: '32px', background: '#f0f5ff', borderRadius: '16px', border: '1px solid #adc6ff' }}>
                                    <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#003a8c', marginBottom: 0 }}>
                                        Ensuring data security protects the reputation of our Hospital and the Rare Disease Research Institute.<br /><br />
                                        Any data breach can lead to loss of public trust, difficulty in future sample recruitment, and damage to institutional credibility.
                                    </Paragraph>
                                </div>
                            </Card>

                            {/* Section 3 */}
                            <Card id="part-3" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <TeamOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    3. Ethics Management Team
                                </Title>
                                <Paragraph style={{ fontSize: '17px', lineHeight: '1.8', color: '#444' }}>
                                    Our Hospital and the Rare Disease Research Institute have appointed dedicated personnel for ethics management, responsible for:
                                </Paragraph>
                                <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
                                    {[
                                        "Reviewing applications and data use protocols",
                                        "Supervising security operations and access audits",
                                        "Providing training and consultation on legal and ethical matters"
                                    ].map((item, index) => (
                                        <Col xs={24} sm={8} key={index}>
                                            <div style={{ padding: '24px', background: '#fafafa', borderRadius: '16px', height: '100%', border: '1px solid #f0f0f0', textAlign: 'center' }}>
                                                <div style={{ fontSize: '24px', color: '#13769a', marginBottom: '12px' }}><CheckCircleOutlined /></div>
                                                <Text strong style={{ fontSize: '15px' }}>{item}</Text>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Card>

                            {/* Section 4 */}
                            <Card id="part-4" bordered={false} style={{ borderRadius: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.06)' }} bodyStyle={{ padding: '48px' }}>
                                <Title level={2} style={{ fontWeight: 800, color: '#055878', marginBottom: '32px', display: 'flex', alignItems: 'center' }}>
                                    <GlobalOutlined style={{ marginRight: '16px', color: '#13769a' }} />
                                    4. Legal and Regulatory Framework
                                </Title>
                                <Paragraph style={{ fontSize: '17px', color: '#444' }}>
                                    All users must comply with the following:
                                </Paragraph>
                                <Row gutter={[12, 12]} style={{ marginTop: '20px' }}>
                                    {[
                                        "Personal Information Protection Law (PIPL)",
                                        "Civil Code of the People’s Republic of China",
                                        "Regulations on the Administration of Human Genetic Resources",
                                        "Biosecurity Law",
                                        "Data Security Law"
                                    ].map((law, i) => (
                                        <Col xs={24} sm={12} key={i}>
                                            <div style={{ padding: '16px 20px', background: '#f5f5f5', borderRadius: '8px', borderLeft: '3px solid #13769a' }}>
                                                <Text strong>{law}</Text>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                                <div style={{ marginTop: '32px', padding: '20px', borderRadius: '12px', background: 'rgba(255, 77, 79, 0.05)', display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                                    <InfoCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px', marginTop: '4px' }} />
                                    <Text type="danger" style={{ fontSize: '15px', fontWeight: 500 }}>
                                        Violations can result in heavy penalties, legal liability, and even criminal charges.
                                    </Text>
                                </div>

                                <Divider style={{ margin: '48px 0' }} />

                                {/* Subsections */}
                                <div id="part-5" style={{ marginBottom: '48px' }}>
                                    <Title level={3} style={{ fontWeight: 800, color: '#055878', marginBottom: '24px' }}>
                                        <SolutionOutlined style={{ marginRight: '12px' }} />
                                        Data Access Management Workflow
                                    </Title>
                                    <div style={{ padding: '32px', background: '#fafafa', borderRadius: '20px' }}>
                                        <Paragraph style={{ fontSize: '16px', lineHeight: '2.2', color: '#555', marginBottom: 0 }}>
                                            1. User completes online registration with institutional credentials.<br />
                                            2. Submits required documentation including project proposal, IRB approval, and data use agreement.<br />
                                            3. Application reviewed by <GsrdWch /> Data Access Committee.<br />
                                            4. Upon approval, access granted to designated datasets based on access level.<br />
                                            5. Periodic audits and renewals required to maintain compliance.
                                        </Paragraph>
                                    </div>
                                </div>

                                <div id="part-6" style={{ marginBottom: '48px' }}>
                                    <Title level={3} style={{ fontWeight: 800, color: '#055878', marginBottom: '24px' }}>
                                        <MonitorOutlined style={{ marginRight: '12px' }} />
                                        Technical Safeguards and Monitoring
                                    </Title>
                                    <ul style={{ fontSize: '16px', lineHeight: '2.2', color: '#555' }}>
                                        <li>All data is hosted on secure institutional infrastructure with encrypted storage and role-based access control.</li>
                                        <li>Bastion host (jump server) access is mandatory for viewing or analyzing raw files.</li>
                                        <li>All data access activities are logged and reviewed regularly.</li>
                                        <li>Users are prohibited from copying, transferring, or storing sensitive data outside of secure environments.</li>
                                        <li>Offline or personal storage devices are strictly disallowed.</li>
                                    </ul>
                                </div>

                                <div id="part-7">
                                    <Title level={3} style={{ fontWeight: 800, color: '#055878', marginBottom: '24px' }}>
                                        <SafetyCertificateOutlined style={{ marginRight: '12px' }} />
                                        Dedicated Institutional Oversight
                                    </Title>
                                    <div style={{ padding: '32px', background: 'linear-gradient(to right, #f0f7ff, #ffffff)', borderRadius: '20px', border: '1px solid #e6f7ff' }}>
                                        <Paragraph style={{ fontSize: '16px', color: '#444' }}>
                                            Our Hospital and the Rare Disease Research Institute have designated a dedicated Ethics & Data Security Unit, responsible for:
                                        </Paragraph>
                                        <ul style={{ fontSize: '15px', color: '#666', lineHeight: '2', marginTop: '16px' }}>
                                            <li>Reviewing all data access applications and collaborative research protocols</li>
                                            <li>Overseeing training on data ethics, cybersecurity, and legal compliance</li>
                                            <li>Handling incident response and breach mitigation</li>
                                            <li>Coordinating with national authorities for compliance audits and certification</li>
                                        </ul>
                                    </div>
                                </div>
                            </Card>

                            <div style={{ height: '60px' }} />
                        </Space>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

